import React, { useContext, useLayoutEffect, useState } from 'react';

import Dialog from './Dialog';

import { LayoutContext } from '../context/layoutContext';
import TitleToOption from '../pages/common/TitleToOption';
import { POPUP_NAME, storageData } from '../constants/index';
import { setCookie } from '../helpers/cookies';
import { TextBox } from '../styles/globalStyles';
import { useHistory } from 'react-router-dom';

import { connect } from 'react-redux';

const MainPopup = ({ open, close, bannerData }) => {
  const { matchese } = useContext(LayoutContext);
  const history = useHistory();

  const [popupData, setPopupData] = useState('');
  const [popupOpen, setPopupOpen] = useState(false);

  useLayoutEffect(() => {
    if (storageData && popupData?.isShow) {
      setPopupOpen(open);
    }
  }, [open, storageData, popupData]);

  useLayoutEffect(() => {
    if (bannerData.length) {
      let banner = bannerData.filter(i => i.category === '팝업').filter(i => i.isShow);

      if (banner.length) {
        setPopupData(banner[0]);
      }
    }
  }, [bannerData]);

  const goUrl = () => {
    if (popupData?.linkType === 'program') {
      if (!popupData?.linkProgram) return;
      history.push(process.env.PUBLIC_URL + `/vod-detail?id=${popupData?.linkProgram?.id}&tab=-1`);
    } else if (popupData?.linkType === 'url') {
      if (!popupData?.link) return;
      window.open(popupData?.link, '_blank');
    }
  };

  const closePopup = option => {
    if (option) {
      var today = new Date();
      today.setDate(today.getDate() + 1);
      setCookie(POPUP_NAME, true, { expires: today });
    }
    close();
  };

  return (
    <Dialog open={popupOpen} close={() => closePopup(false)} style={{ padding: '5px' }}>
      <div>
        <TitleToOption title='' optionType='close' rtOptionClick={() => closePopup(false)} />
        <div onClick={goUrl} style={{ cursor: 'pointer' }}>
          {popupData && (
            <img
              alt='promotionBanner'
              src={matchese ? popupData?.mobileImg?.url : popupData?.img?.url}
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          )}
        </div>
      </div>
      <TextBox style={{ fontSize: '13px', cursor: 'pointer' }} onClick={() => closePopup(true)}>
        오늘 하루 더이상 보지 않음
      </TextBox>
    </Dialog>
  );
};

const mapStateToProps = state => {
  return {
    bannerData: state.bannerData.banner,
  };
};

export default connect(mapStateToProps)(MainPopup);
